import React, { useState } from 'react';
import { Box, Typography, List, ListItemButton, ListItemText, Divider, Chip, Stack, TextField, InputAdornment, MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SearchIcon from '@mui/icons-material/Search';

const statusMap = {
  invited: { label: 'Davetli', color: 'default' },
  confirmed: { label: 'Katılacak', color: 'success' },
  declined: { label: 'Katılmayacak', color: 'error' }
};

const MisafirlerTab = ({ participants, tables, onEditParticipant }) => {
  const [search, setSearch] = useState('');
  const [sideFilter, setSideFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');

  // Katılımcıların masa adını bul
  function getTableNameForParticipant(participantId) {
    for (const t of tables) {
      if ((t.seats || []).some(s => s.participant_id === participantId)) {
        return t.name;
      }
    }
    return '';
  }

  // Filtre seçenekleri
  const allSides = Array.from(new Set(participants.map(p => p.side).filter(Boolean)));
  const allStatuses = Array.from(new Set(participants.map(p => p.status).filter(Boolean)));

  // Katılımcıları sıralı ve filtreli göster
  const sortedParticipants = [...participants]
    .filter(p =>
      (!search || (p.name && p.name.toLocaleLowerCase('tr').includes(search.toLocaleLowerCase('tr')))) &&
      (sideFilter === 'all' || p.side === sideFilter) &&
      (statusFilter === 'all' || p.status === statusFilter)
    )
    .sort((a, b) => a.name.localeCompare(b.name, 'tr', { sensitivity: 'base' }));

  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={2}>
        <TextField
          size="small"
          placeholder="Misafir ara..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Taraf</InputLabel>
          <Select
            value={sideFilter}
            label="Taraf"
            onChange={e => setSideFilter(e.target.value)}
          >
            <MenuItem value="all">Tümü</MenuItem>
            {allSides.map(side => (
              <MenuItem key={side} value={side}>{side}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 140 }}>
          <InputLabel>Durum</InputLabel>
          <Select
            value={statusFilter}
            label="Durum"
            onChange={e => setStatusFilter(e.target.value)}
          >
            <MenuItem value="all">Tümü</MenuItem>
            {allStatuses.map(status => (
              <MenuItem key={status} value={status}>{statusMap[status]?.label || status}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
      <List>
        {sortedParticipants.map((p, idx) => {
          const masa = getTableNameForParticipant(p.id);
          const side = p.side || '';
          const status = statusMap[p.status] || statusMap['invited'];
          return (
            <React.Fragment key={p.id}>
              <ListItemButton onClick={() => onEditParticipant(p)} alignItems="flex-start" sx={{ py: 2 }}>
                <ListItemText
                  primary={
                    <Typography fontWeight={700} fontSize={18} gutterBottom>
                      {idx + 1}. {p.name}
                    </Typography>
                  }
                  secondary={
                    <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
                      <Typography variant="body2" color="text.secondary">
                        {masa && <span>Masa: <b>{masa}</b></span>}
                        {side && <span style={{ marginLeft: masa ? 12 : 0 }}>Taraf: <b>{side}</b></span>}
                      </Typography>
                      <Chip
                        label={status.label}
                        color={status.color}
                        size="small"
                        sx={{ ml: 1, fontWeight: 500 }}
                      />
                    </Stack>
                  }
                />
                <ChevronRightIcon sx={{ color: 'grey.400', ml: 1, alignSelf: 'center' }} />
              </ListItemButton>
              <Divider />
            </React.Fragment>
          );
        })}
      </List>
    </Box>
  );
};

export default MisafirlerTab; 